import React from "react";
import EditIcon from "../assets/icons/edit-icon.svg";
import DeleteIcon from "../assets/icons/delete-icon.svg";
import "../styles/components/winner_item.css";

const WinnerItem = ({ winner, index, onEdit, onDelete }) => {
    return (
        <div className="winner-item">
            <h3 className="winner-item-title">
                {index}. {winner.fullName}
            </h3>
            <div className="winner-item-actions">
                <button
                    type="button"
                    className="winner-item-btn winner-item-edit"
                    onClick={() => onEdit(winner)}
                >
                    <img src={EditIcon} alt="Редактировать" />
                </button>
                <button
                    type="button"
                    className="winner-item-btn winner-item-delete"
                    onClick={() => onDelete(winner.id)}
                >
                    <img src={DeleteIcon} alt="Удалить" />
                </button>
            </div>
        </div>
    );
};

export default WinnerItem;
